export const BannersList = {
  state: {
    banners: [],
  },

  getters: {
    allBanners: (state) => {
      return state.banners;
    },
  },

  mutations: {
    addBanners(state, banners) {
      state.banners = banners;
    },
    dismissBanner(state, banner) {
      state.banners = state.banners.filter((el) => el !== banner);
    },
  },
  actions: {
    async getBanners(ctx) {
      const response = await this._vm.$api('banners.get', { version: '1.0' });
      ctx.commit('addBanners', response.data);
    },
    async dismissBanner(ctx, bannerId) {
      const response = await this._vm.$api('banner.dismiss', { version: '1.0', banner: bannerId });
      ctx.commit('dismissBanner', response.data.data.component);
    },
    async clickBanner(ctx, bannerId) {
      const response = await this._vm.$api('banner.click', { version: '1.0', banner: bannerId });
    },
  },
};
